import React, { useState , useEffect} from "react";
import {
  Button,
  Form,
  notification,
  Select,
  Upload,
  Space,
  Input,
  message,
  Image,
} from "antd";
import { DatePicker } from 'antd';
import { useParams } from "react-router-dom";
import dayjs from 'dayjs';
import { AiOutlineRight } from "react-icons/ai";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { GrUpload } from "react-icons/gr";
import CouponsRequest from "./CouponsRequest";

import { useNavigate } from "react-router-dom";

const EditCoupon = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [fileList, setFileList] = useState([]);
  const [submited, setSubmit] = useState(false);
  const [couponDetails, setCouponDetails] = useState({});
  const [form] = Form.useForm();
  const { id } = useParams();
  const update = () => {
    setSubmit(true);
  };

   useEffect(() => {

    const getCouponsDetails = async () => {
      setLoading(true);
      try {
        const res = await CouponsRequest.couponDetail(id);
        const couponData = res?.data?.data;
        console.log(couponData)
        if (couponData) {

          const mappedData = {
            ...couponData,
            type : couponData.type === 1 ? "percentage" : "fix",
            status: couponData.status === 1 ? "0" : "1",
             ownerType: couponData.ownerType === 2 ? "2" : undefined, 
          };

          setCouponDetails(mappedData);
          console.log(setCouponDetails)
          form.setFieldsValue({
            couponCode: mappedData.couponCode,
            type: mappedData.type,
            minimumOrderValue : mappedData.minimumOrderValue,
            status: mappedData.status,
            value : mappedData.value,
            ownerType : mappedData.ownerType,
            expiredAt : dayjs(mappedData.expiredAt),
          });

          
        }
      } catch (e) {
        console.log(e);
      } finally {
        setLoading(false);
      }
    };

    if (id) getCouponsDetails();
  }, [id, form]);

 const onFinish = (values) => {
    console.log("Form values:", values);
    if(submited){
    setLoading(true);
    const formData = { ...values, id };
    CouponsRequest.updateCoupon(formData)
      .then((res) => {
        if (res.status === 200) {
          notification["success"]({
            message: "coupon updated successfully",
          });
          navigate(-1, { state: { refresh: true } });
        } else {
          notification["error"]({
            message: "Something went wrong",
          });
        }
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        // notification["error"]({
        //   message: "Failed",
        // });
      });
    }
  };

  return (
    <section>
      <div className="Create-coupon">
        <div span={24}>
          <Form.Item className="submit-btn">
            <Space>
              <Button
                className="f-sub-btn btn-width"
                onClick={() => navigate(-1)}
                disabled={loading}
              >
                <ArrowLeftOutlined />
              </Button>
            </Space>
          </Form.Item>
        </div>
        <h3>Update Coupon</h3>

        <Form
          form={form}
          onFinish={onFinish}
          layout="vertical"
          initialValues={null}
          className="subscription-form"
          colon={true}
        >
          <div className="subscription">
            <Form.Item
              label="Coupon Code"
              name="couponCode"
              className="subscription-plan"
              rules={[
                { required: true, message: "Please enter the Coupon code!" },
                {
                  pattern: /^[A-Za-z0-9]+$/,
                  message: "Coupon code can only contain alphanumeric characters!",
                },
              ]}
            >
              <Input size="large" placeholder="Enter coupon Name" />
            </Form.Item>

            <Form.Item
              label="Coupon Status"
              name="status"
              className="subscription-plan"
              rules={[
                { required: true, message: "Please select the coupon status" },
              ]}
            >
              <Select
                placeholder="Select The coupon Status"
                // style={{ marginTop: "0.5rem", width: "99%" }}
                options={[
                  { value: "1", label: "Active" },
                  { value: "0", label: "Inactive" },
                ]}
              />
            </Form.Item>
          </div>

          <div className="subscription">
            <Form.Item
              label="Coupon Type"
              name="type"
              className="subscription-plan"
              rules={[
                { required: true, message: "Please select the coupon type" },
              ]}
            >
              <Select
                placeholder="Select The coupon Gender"
                // style={{ marginTop: "0.5rem", width: "99%" }}
                options={[
                  { value: "1", label: "percentage" },
                  { value: "2", label: "Fix" },
                ]}
              />
            </Form.Item>
            <Form.Item
              label="Minimum Order Value"
              name="minimumOrderValue"
              className="subscription-plan"
              rules={[
                // { required: true, message: "Please enter the MOV!" },
                {
                  pattern: /^[0-9]+$/,
                  message: "Must be a valid number!",
                },
              ]}
            >

                    <Input size="large" placeholder="Enter MOV" />
            </Form.Item>
          </div>
          <div className="subscription">
            <Form.Item
              label="Value"
              name="value"
              className="subscription-plan"
              rules={[
                { required: true, message: "Please enter the value!" },
                  {
                  pattern: /^[0-9]+$/,
                  message: "Must be a valid number!",
                },
              ]}
            >
                   <Input size="large" placeholder="Enter Value" /> 
            </Form.Item>

            <Form.Item
              label="Owner Type"
              name="ownerType"
              className="subscription-plan"
              rules={[
                { required: true, message: "Please select the owner type" },
              ]}
            >
              <Select
                placeholder="Select The coupon owner type"
                // style={{ marginTop: "0.5rem", width: "99%" }}
                options={[
             
                  { value: "2", label: "Admin" },
                ]}
              />
            </Form.Item>

          </div>
          <div className="subscription">
           <Form.Item
  label="Expired At"
  name="expiredAt"
  rules={[
    { 
      required: true, 
      message: "Please select expiration date" 
    },
    ({ getFieldValue }) => ({
      validator(_, value) {
        if (!value || value.isAfter(dayjs())) {
          return Promise.resolve();
        }
        return Promise.reject(new Error('Expiration date must be in the future'));
      },
    }),
  ]}
>
  <DatePicker 
  
    format="YYYY-MM-DD"
    style={{ width: '100%' }}
    disabledDate={(current) => {
      // Can not select days before today
      return current && current < dayjs().startOf('day');
    }}
  />
</Form.Item>

          </div>

          <div className="bottom-button">
            <div style={{ padding: "10px" }}>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}

                  onClick={update}
              >
                Save & Proceed
                <span>
                  <AiOutlineRight />
                </span>
              </Button>
            </div>
          </div>
        </Form>
      </div>
    </section>
  );
};

export default EditCoupon;
